<template>
    <div v-loading="loading">
        <div ref="stageChart" :style="{ height: map_height, width: '100%' }"></div>
    </div>
</template>
<script>
import CustomerCount from "~/services/CustomerCount";
import echarts from "echarts";

export default{
    props:{
        params:{
            type: Object,
            required: true,
        },
        map_height:{
            type: String,
            default: '400px',
        }
    },
    data() {
        return {
            loading: false,
            labels: [],
            count_list: [],
        };
    },
    created(){
        this.getData(this.params);
    },
    
    methods: {
        //渠道申请分析
        getData(params) {
            // loading 动画
            this.loading = true;
            CustomerCount.getCount(params, 'stage-chart')
            .then((res) => {
                if (res.code == 0) {
                    this.labels = res.data.labels;
                    this.count_list = res.data.list;
                    this.initChart();
                }
                this.loading = false;
            }).catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },

        initChart() {
            if(this.count_list.length == 0 || this.labels.length == 0){
                return false;
            }
            const chartContainer = this.$refs.stageChart;
            if (!chartContainer){
                return false;
            }
            const myChart = echarts.init(chartContainer);
            let option = {
                color: [
                    '#5470c6',
                    "#91cc75",
                    "#fac858",
                    "#ee6666",
                    "#73c0de",
                    "#3dac78",
                    '#C280FF',
                    '#34B7FB',
                    '#81D3F8',
                    '#95F204',
                    '#F56C6C',
                    '#04D919',
                    '#FFA680',
                    '#B1DDF5',
                    '#CBE7F4',
                    '#D2F2A0',
                    '#F3C4C4',
                    '#A0E9A8',
                    '#F6D8CB',
                    '#8080FF',
                    '#FF4D00',
                ],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {},
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: this.labels,
                        // axisLabel:{
                        //     interval:0, //控制X轴刻度全部显示
                        //     rotate:45 //倾斜角度
                        // }
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                toolbox: {
                    show: true,
                    orient: 'vertical',
                    left: 'right',
                    top: 'center',
                    feature: {
                        mark: {show: true},
                        dataView: {show: true, readOnly: false},
                        magicType: {show: true, type: ['line', 'bar', 'tiled']},
                        restore: {show: true},
                        saveAsImage: {show: true}
                    }
                },
                series: []
            };
            this.count_list.forEach(item => {
                const nonZeroData = Object.values(item.children).some(value => value !== 0);
                if(nonZeroData){
                    option.series.push(
                        {
                            name: item.name,
                            type: 'bar',
                            emphasis: {
                                focus: 'series'
                            },
                            data: Object.values(item.children)
                        },
                    );
                }
            });
            myChart.setOption(option, true);
            
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/views/count/echarts/customerStageChart.vue